import { render, staticRenderFns } from "./TableSku.vue?vue&type=template&id=6a1e0e3c&scoped=true"
import script from "./TableSku.vue?vue&type=script&lang=js"
export * from "./TableSku.vue?vue&type=script&lang=js"
import style0 from "./TableSku.vue?vue&type=style&index=0&id=6a1e0e3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e0e3c",
  null
  
)

export default component.exports